export default {
  16: 'boys',
  48: 'girls',
  75: 'men',
  136: 'women',
  165: 'babygirls',
  166: 'babyboys',
  2180: 'genderneutral',
};
